/**
 * error-reporter seam for code shared across builds
 *
 * fetchUtils is bundled into the SPA, the sirius-bridge, and every test
 * graph — a static @sentry/sveltekit import there drags $app/stores into
 * builds that cannot resolve it (see docs/SENTRY.md P4: the bridge stays a
 * Sentry blind spot for now). The SPA registers Sentry.captureException in
 * hooks.client.ts / hooks.server.ts; everywhere else reporting is a no-op.
 */

type ExceptionReporter = (error: Error, context?: { extra?: Record<string, unknown> }) => void

let reporter: ExceptionReporter = () => {}

export function setExceptionReporter(nextReporter: ExceptionReporter): void {
	reporter = nextReporter
}

export function reportException(error: Error, context?: { extra?: Record<string, unknown> }): void {
	reporter(error, context)
}
